import HttpHelper from './helper';

export const calendarEndpoints = {
  get: (params) => HttpHelper.baseAxios
    .get(`/calendar`, { params })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data),
};
